import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { UserRole } from '@/services/ws-permissions/src/main/resources/rest-api';
import { PermissionType } from '@/js/libs/generated/permissions/types';
import { AGENCY_ROLES, YALEO_SELF_BOOKING_USER_ROLES } from './constants';
import { useTokenStorage } from './hooks';
import { CombinedRole } from './types';
const AuthContext = React.createContext({});
const AuthProvider = ({ children }) => {
    const { getAuthToken } = useTokenStorage();
    const [token, setToken] = React.useState(getAuthToken);
    const [identity, setIdentity] = React.useState({
        user: undefined,
        loading: false,
        initialized: false,
    });
    const identityRoles = React.useMemo(() => {
        const user = identity?.user;
        if (!user?.id) {
            return [PermissionType.ANONYMOUS];
        }
        const isAgencyRelatedRoles = user.userRole === UserRole.ADMIN || AGENCY_ROLES.some((role) => user.permissions?.includes(role));
        const isPublisher = user.userRole === UserRole.ADMIN || user.permittedWebsiteIds.length > 0;
        const isSelfBookingUser = user.permissions.some((permission) => permission === PermissionType.YALEO_SELF_BOOKING) &&
            user.permissions.every((permission) => YALEO_SELF_BOOKING_USER_ROLES.includes(permission));
        return [
            user.userRole,
            ...(user.permissions || []),
            ...(isPublisher ? [CombinedRole.PUBLISHER] : []),
            ...(isAgencyRelatedRoles ? [CombinedRole.AGENCY] : []),
            ...(isSelfBookingUser ? [CombinedRole.YALEO_SELF_BOOKING_USER] : []),
        ].filter((role) => !!role);
    }, [identity]);
    const value = React.useMemo(() => ({
        identity,
        setIdentity,
        identityRoles,
        token,
        setToken,
    }), [identity, setIdentity, identityRoles, token, setToken]);
    return _jsx(AuthContext.Provider, { value: value, children: children });
};
export { AuthContext, AuthProvider };
